import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fui-modal-window",
    styleUrls: ["./modal-window.component.scss"],
    templateUrl: "./modal-window.component.html"
})
export class FUIModalWindowComponent {
    @Input() public alert: boolean;
    @Input() public icon: string;
    @Input() public title: string;

    constructor() {

    }
}
